import * as React from 'react';

import { Card, CardContent, CardHeader } from '../../ui/card';
import { Skeleton } from '../../ui/skeleton';

export interface FormPageSkeletonProps {
  /** Whether to show action button skeletons at the bottom */
  actions?: boolean;
  /** Array where each number is the count of skeleton field pairs in a card section */
  sections: number[];
}

export function FormPageSkeleton({ actions, sections }: FormPageSkeletonProps): React.JSX.Element {
  return (
    <div className="space-y-6" role="status" aria-label="Loading">
      {sections.map((fieldCount, sectionIndex) => (
        <Card key={sectionIndex}>
          <CardHeader>
            <Skeleton className="h-6 w-48" />
          </CardHeader>
          <CardContent>
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
              {Array.from({ length: fieldCount }, (_, fieldIndex) => (
                <div className="space-y-2" key={fieldIndex}>
                  <Skeleton className="h-4 w-24" />
                  <Skeleton className="h-4 w-full" />
                </div>
              ))}
            </div>
          </CardContent>
        </Card>
      ))}
      {actions && (
        <div className="flex gap-3">
          <Skeleton className="h-10 w-24" />
          <Skeleton className="h-10 w-24" />
        </div>
      )}
    </div>
  );
}
